module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/no-data/no-data.component.scss
// module id = ./src/app/modules/common-module/components/no-data/no-data.component.scss
// module chunks = 9